<app-navbar></app-navbar>
<main class="page-container container-fluid">
  <router-outlet></router-outlet>
</main>
